import React from "react";
import numeral from "numeral";

type Props = {
    data: any;
};

const TreatyDeductionFormSummary = ({ data }: Props) => {
    return (
        <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3">
            <div>
                <div className="grid grid-cols-3 gap-6">
                    <div className="">
                        <span className="block text-sm  text-secondary">
                            New Policy Number
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {data?.policy_number || "N/A"}
                        </div>
                    </div>
                    <div className="col-span-2">
                        <span className="block text-sm  text-secondary">
                            Insured
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {data?.insured_by || "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Sum Insured
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {data?.sum_insured || "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Rate
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {data?.rate || "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Premioum
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {data?.premium || "N/A"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TreatyDeductionFormSummary;
